import { render, staticRenderFns } from "./Ontraport.vue?vue&type=template&id=5624d6b6"
import script from "./Ontraport.vue?vue&type=script&lang=js"
export * from "./Ontraport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports